//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { MatchPurchaseOrders, PurchaseInvoice, PurchaseInvoiceQuick } from '../../graphql/entities';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { Direction, IPurchaseInvoice } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';
import { useAttributesForWorkspace } from '../../components/Workspace/useAttributesForWorkspace';
import supplierAttributeQuery from '../../graphql/queries/supplier/SupplierAttributeConfigListQuery.graphql';
import { ModalFormatter } from '../../components/grid-addons/formatters/ModalFormatter';

const LazySupplierForm = React.lazy(() => import('../../views/supplier/SupplierForm'));
const { readOnlyStatus, formUrl, type, title, workspace } = PurchaseInvoice;
const { formUrl: matchFormUrl } = MatchPurchaseOrders;
const { formUrl: quickFormUrl } = PurchaseInvoiceQuick;

const PURCHASE_INVOICE_DEFAULT_FIELD_NAMES: Array<Paths<IPurchaseInvoice>> = [
  'documentNumber',
  'documentDate',
  'documentStatus',
  'supplier.reference',
  'supplier.name',
  'documentReference',
  'documentAmount',
];

const PURCHASE_INVOICE_COLUMN_OVERRIDES = {
  documentNumber: {
    name: 'Number',
    key: 'documentNumber',
    width: 100,
  },
  documentDate: {
    name: 'Date',
    key: 'documentDate',
    formatter: Formatters.DateFormatter,
    width: 110,
  },
  documentAmount: {
    name: 'Invoice Total',
    width: 150,
    formatter: Formatters.NumericFormatter,
    options: {
      format: { decimals: 2 },
    },
  },
  'supplier.reference': {
    name: 'Supplier',
    formatter: ModalFormatter,
    width: 125,
    options: {
      modalContent: LazySupplierForm,
      modalProps: { forceReadOnly: true },
      entityId: 'supplier.id',
    },
  },
  documentStatus: {
    name: 'Status',
    formatter: Formatters.DocumentStatusFormatter,
    width: 100,
  },
  purchaseOrderMatching: {
    name: 'Purchase Order Matched',
  },
  documentReference: {
    name: 'Reference',
  },
  purchasePaymentStatus: {
    name: 'Disputed',
  },
};

const PurchaseInvoiceWorkspace = (props) => {
  const supplierAttributeColumns = useAttributesForWorkspace(supplierAttributeQuery, {
    valuesPath: 'supplier.attributeValues',
    columnKey: 'supplier.attributeValues.attributeConfig.title',
  });

  const workspaceProps = useWorkspace<IPurchaseInvoice>(props, PurchaseInvoice, {
    columns: PURCHASE_INVOICE_DEFAULT_FIELD_NAMES,
    customColumns: supplierAttributeColumns,
    columnOverrides: PURCHASE_INVOICE_COLUMN_OVERRIDES,
    initialSortColumn: 'documentNumber',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={type}
      title={title}
      formUrl={formUrl}
      defaultQuery={workspace}
      duplicate={true}
      readOnlyStatus={readOnlyStatus}
      addButtons={[
        {
          url: `${formUrl}New`,
          description: 'Add Invoice',
        },
        {
          url: `${matchFormUrl}New`,
          description: 'Add Invoice and Match',
        },
        {
          url: `${quickFormUrl}New`,
          description: 'Add Quick Invoice',
        },
      ]}
      {...workspaceProps}
      {...props}
      entity={PurchaseInvoice}
    />
  );
};

export default PurchaseInvoiceWorkspace;
